/**
 * Flipnovel 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Flipnovel 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: brandTheme.borderPrimary,
  // 按钮背景色
  btnPrimaryBg: 'rgba(255, 255, 255, 0.1)',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #C8E858 0%, #9AD844 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/flipnovel/member_subscribe_bg.webp)',
  subscribeBg: 'linear-gradient(100deg, #2E2118 0%, #1E1510 60%, #2A1D15 100%)',
  subscribeText: '#D4B896',
  subscribeText2: 'rgba(212, 184, 150, 0.55)',
  vipBtnBg: 'linear-gradient(90deg, #D4B896 0%, #B89A78 100%)',
} as const

/**
 * Flipnovel 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '',
  // 用户背景图
  userBg: '',
  // 用户默认头像
  userDefaultAvatar: '/images/flipnovel/user-default.svg?v=3',
  // VIP 图标
  memberVip: '/images/flipnovel/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/flipnovel/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
